var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "57.022px",
    height: "57.022px",
    viewBox: "0 0 57.022 57.022",
    enableBackground: "new 0 0 57.022 57.022",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.511,
    cy: 28.511,
    r: 28.511
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.707,44.527V20.428h-4.395V16.82c3.192-0.324,4.579-2.266,5.227-4.672h4.949v32.378H26.707z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet1);
export default __webpack_public_path__ + "static/media/Bullet1.e75da5e6df4192c4b94818156c8e205b.svg";
export { ForwardRef as ReactComponent };